import React from "react";

import styles from "./workflow.module.css";

export interface WizardNavigationProps {
  steps: string[];
  active: number;
  farthest: number;
  chooseStep: (step: number) => void;
}

const WizardNavigation: React.FC<WizardNavigationProps> = ({
  steps,
  active,
  farthest,
  chooseStep,
}): JSX.Element => {
  const hasVisited = (i: number): boolean => {
    return farthest >= i;
  };

  const navigation = steps.map((step, i) => (
    <li key={step} className={`step-${i + 1}`}>
      <small className={styles["custom-step-number"]}>{`Step ${i + 1}`}</small>
      <br />
      {hasVisited(i) && active !== i ? (
        <a
          href="javascript:void(0);"
          onClick={() => chooseStep(i)}
          className="visited"
          rel="noopener noreferrer"
        >
          {steps[i]}
        </a>
      ) : (
        <span
          className={
            active === i ? styles["active-nav-step"] : styles["disabled"]
          }
        >
          {steps[i]}
        </span>
      )}
    </li>
  ));
  return (
    <ul
      className={`${styles["awsui-list-unstyled"]} ${styles["custom-wizard-navigation"]}`}
    >
      {navigation}
    </ul>
  );
};

export default WizardNavigation;
